import React from 'react';
import Header from './components/Header';
import Copywrite from "./components/copywrite"
import DataWrapper from './components/DataWrapper';
import { contentArray } from './constant/data';

const Disclaimer = () => {
  return (
    <div>
      {/* Header with Title and Last Updated Info */}
      <Header Title="Disclaimer" lastUpdated="Last Updated on January 1st, 2025" />
      
      <div className="md:p-12 p-6 max-w-7xl mx-auto">
        <DataWrapper heading="">
          {contentArray.map((paragraph, index) => (
            <p key={index} className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
              {paragraph}
            </p>
          ))}
        </DataWrapper>

        <div className="flex items-center justify-center w-full">
          <Copywrite />
        </div>
      </div>

    </div>
  );
};

export default Disclaimer;
